import { useId } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@dorixona/i18n'
import { Press } from '@dorixona/ui'
import { useLatestNews } from '../api'
import { NewsCard, NewsCardSkeleton } from './NewsCard'

const SKELETON = [0, 1]

/**
 * Новости на главной: заголовок секции со ссылкой «Все» и ряд свежих новостей,
 * который листается вбок. Следующая карточка выглядывает из-за края — так
 * видно, что ряд продолжается (scroll-views.md › Make it apparent when content
 * is scrollable). Полка — не содержимое главной: при ошибке или пустой ленте
 * её просто нет.
 */
export function NewsShelf() {
  const { t, i18n } = useTranslation(['home', 'common'])
  const language = resolveLanguage([i18n.language])
  const navigate = useNavigate()
  const news = useLatestNews()
  const headingId = useId()

  if (news.isPending) {
    return (
      <div className="sect" role="status" aria-busy="true">
        <span className="visually-hidden">{t('common:state.loading')}</span>
        <div aria-hidden="true">
          <div className="sect-head">
            <i className="sk-b sk-l news-sk-head" />
          </div>
          <div className="news-rail">
            {SKELETON.map((i) => (
              <NewsCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    )
  }

  const list = news.data ?? []
  if (list.length === 0) return null

  return (
    <section className="sect" aria-labelledby={headingId}>
      <div className="sect-head">
        <h2 id={headingId}>{t('home:news.title')}</h2>
        <Press
          squish="chip"
          onPress={() => {
            void navigate('/news')
          }}
        >
          {t('home:news.all')}
        </Press>
      </div>
      <ul className="news-rail">
        {list.map((item) => (
          <li key={item.id}>
            <NewsCard item={item} language={language} />
          </li>
        ))}
      </ul>
    </section>
  )
}
